import api from "@/service";
import { Toast } from "antd-mobile";
import { routerRedux } from "dva/router";
const {
    adminFindLoginName,
    adminUpdate,
    adminAdd,
    adminAdd2,
    currencyCountOfAdmin,
    adminList,
    currencyGrant,
    currencyRetrieve,
    adminQuotaList,
    apiAdminJoinFuncGroup,
    apiUserJoinFuncGroup,
    apiAdminRenewByCurrency,
    adminCurrencyRecordList,
    apiAdminAllPermissions,
    apiAdminPermissionsById,
    apiSetAdminPermissionsById,
    adminAllocationFunctionGrp,
    adminSetPreferentialMonth,
    adminAssignFuncGroup,
    adminRetrieveList,
} = api;
export default {
    namespace: "admin",
    state: {
        loginMsgUser: {},
        adminListDatas: [],
        pageNo: 0,
        pageTotal: 0,
        adminCurrencyCount: {
            totalCount: 0,
            surplusCount: 0,
            usedCount: 0,
        },
        retrieveAdminList: [],
    },
    subscriptions: {
        setup({ dispatch, history }) {
            history.listen(location => {
                console.log(location, "admin");
                if (/addadmin/.test(location.pathname) || /adminFuncRenew/.test(location.pathname)) {
                    dispatch({
                        type: "app/getFuncGroupList",
                        payload: {
                            pageNo: 1,
                            pageSize: 1000,
                        },
                    });
                }
            });
        },
    },
    effects: {
        *getAdminFindLoginName({ payload }, { put, call }) {
            let data = yield call(adminFindLoginName, payload);
            if (data.status == 200 && data.data) {
                yield put({
                    type: "updateState",
                    payload: {
                        loginMsgUser: data.data,
                    },
                });
            } else {
                yield put({
                    type: "updateState",
                    payload: {
                        loginMsgUser: {},
                    },
                });
            }
        },
        *adminAddManager({ payload }, { put, call }) {
            let data = yield call(adminAdd, payload);
            if (data.status == 200) {
                Toast.success(data.message, 1.5);
                window.history.go(-1);
            } else {
                Toast.fail(data.message, 1.5);
            }
        },
        *adminAddManager2({ payload }, { put, call }) {
            let data = yield call(adminAdd2, payload);
            if (data.status == 200) {
                Toast.success(data.message, 1.5);
                window.history.go(-1);
            } else if (data.status == 392) {
                Toast.fail("虚拟币不足");
            } else {
                Toast.fail(data.message, 1.5);
            }
        },
        *adminUpdateManager({ payload }, { put, call }) {
            let data = yield call(adminUpdate, payload);
            if (data.status == 200) {
                Toast.success(data.message, 1.5);
                window.history.go(-1);
            }
        },
        *getAdminList({ payload }, { put, call }) {
            let adminListData = yield call(adminList, payload);
            if (
                adminListData.status == 200 &&
                adminListData.data &&
                adminListData.data.resultList
            ) {
                let adminList = adminListData.data.resultList;
                let adminCurrencyCount = yield call(
                    currencyCountOfAdmin,
                    adminListData.data.resultList.map(item => item.id),
                );
                if (adminCurrencyCount.status == 200) {
                    adminList = adminList.map(item => {
                        return {
                            ...item,
                            ...(adminCurrencyCount.data
                                ? adminCurrencyCount.data[item.id]
                                : {}),
                        };
                    });
                    console.log(adminList, 7777);
                    yield put({
                        type: "updateState",
                        payload: {
                            adminListDatas: adminList || [],
                            pageNo: adminListData.data.pageNo,
                            pageTotalNum: Math.ceil(
                                adminListData.data.totalCount / 10,
                            ),
                        },
                    });
                }
            } else {
                yield put({
                    type: "updateState",
                    payload: {
                        adminListDatas: [],
                        pageNo: 0,
                        pageTotalNum: 0,
                    },
                });
            }
            return Promise.resolve(true);
        },
        //获取单个管理员的虚拟币信息
        *getCurrencyCount({ payload }, { put, call }) {
            let data = yield call(currencyCountOfAdmin, payload);
            console.log(data);
            if (data.status == 200) {
                yield put({
                    type: "updateState",
                    payload: {
                        adminCurrencyCount: data.data && Object.keys(data.data).length > 0
                            ? data.data[payload[0]]
                            : {
                                totalCount: 0,
                                surplusCount: 0,
                                usedCount: 0,
                            },
                    },
                });
            } else {
                Toast.fail(`${data.message}`, 3);
            }
        },
        //获取多个管理员的虚拟币信息
        *getListCurrencyCount({ payload }, { put, call }) {
            let data = yield call(currencyCountOfAdmin, payload);
            console.log(data);
            if (data.status == 200) {
                return data.data;
            }
        },
        //下发虚拟币
        *adminCurrencyGrant({ payload }, { put, call }) {
            let data = yield call(currencyGrant, payload);
            if (data.status == 200) {
                setTimeout(() => window.history.go(-1), 1500);
            } else if (data.status == 392) {
                Toast.fail(data.message);
            } else {
                Toast.success(data.message);
            }
        },
        //回收虚拟币
        *adminCurrencyRetrieve({ payload }, { put, call }) {
            let data = yield call(currencyRetrieve, payload);
            if (data.status == 200) {
                setTimeout(() => window.history.go(-1), 1500);
            } else if (data.status == 392) {
                Toast.fail(data.message);
            } else {
                Toast.success(data.message);
            }
        },
        //获取用户的虚拟币列表
        *getQuotaUsersList({ payload }, { put, call }) {
            let data = yield call(adminQuotaList, payload);
            if (data.status == 200 && data.data.resultList) {
                let resultList = data.data.resultList;
                let idArr = resultList.map(item => item.adminId);
                let currencyData = yield call(currencyCountOfAdmin, idArr);
                console.log(currencyData);

                if (currencyData.status == 200) {
                    resultList = resultList.map(item => {
                        return {
                            ...item,
                            ...(currencyData.data
                                ? currencyData.data[item.adminId] || {}
                                : {}),
                        };
                    });
                }
                return {
                    resultList,
                    totalCount: data.data.totalCount,
                };
            }
        },
        //获取管理员加入的功能组
        *getAdminJoinFunctions({ payload }, { call, put }) {
            let data = yield call(apiAdminJoinFuncGroup, payload)
            if (data.status == 200) {
                return data;
            } else {
                Toast.fail(data.message);
            }
        },
        //获取终端加入的功能组
        *getUserJoinFunctions({ payload }, { call, put }) {
            let data = yield call(apiUserJoinFuncGroup, payload)
            if (data.status == 200) {
                return data;
            } else {
                Toast.fail(data.message);
            }
        },
        //用户虚拟币续费
        *renewByCurrency({ payload }, { put, call }) {
            let datas = yield call(apiAdminRenewByCurrency, payload)
            return datas
        },
        //获取虚拟币操作记录
        *getcurrencyRecordList({ payload }, { put, call }) {
            let data = yield call(adminCurrencyRecordList, payload);
            return data;
        },
        //获取所有权限
        *getAdminAllPermissions({ payload }, { call, put }) {
            let data = yield call(apiAdminAllPermissions, payload)
            if (data.status == 200) {
                return data;
            } else {
                Toast.fail(data.message);
            }
        },
        //获取管理员权限
        *getAdminPermissionsById({ payload }, { call, put }) {
            let data = yield call(apiAdminPermissionsById, payload)
            if (data.status == 200) {
                return data;
            } else {
                Toast.fail(data.message);
            }
        },
        //设置管理员权限
        *setAdminPermissionsById({ payload }, { call, put }) {
            let data = yield call(apiSetAdminPermissionsById, payload)
            if (data.status == 200) {
                return data;
            } else {
                Toast.fail(data.message);
            }
        },
        //分配功能组
        *setAdminFuncGrp({ payload }, { call, put }) {
            const { targetId, months } = payload
            let data = yield call(adminAllocationFunctionGrp, payload)
            if (data.status == 200) {
                let datas = yield call(adminSetPreferentialMonth, { targetId, months })
                return datas;
            } else {
                Toast.fail(data.message);
            }
        },
        //获取总管理设置的优惠组
        *getAssignFuncGroup({ payload }, { call, put }) {
            let datas = yield call(adminAssignFuncGroup, payload)
            if (datas.status == 200) {
                return datas
            } else {
                Toast.fail(datas.message);
            }
        },
        *getRetrieveAdminList({ payload }, { put, call }) {
            let datas = yield call(adminRetrieveList, payload);
            if (datas.status == 200) {
                const { data } = datas;
                yield put({
                    type: "updateState",
                    payload: {
                        retrieveAdminList: data.resultList || [],
                        pageNo: data.pageNo,
                        pageTotalNum: Math.ceil(
                            data.totalCount / 10,
                        ),
                    },
                });
            } else {
                Toast.fail(datas.message);
            }
        },
    },
    reducers: {
        updateState(state, { payload }) {
            return {
                ...state,
                ...payload,
            };
        },
    },
};
